import { Spacing } from "@lifesg/react-design-system/theme";
import styled from "styled-components";

export const FlexWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: ${Spacing["spacing-16"]};
`;
